<script lang="ts">
    import type {InputDescription} from './types';
    import {exists} from 'shared/utils/custom-utils';

    export let inputDescription: InputDescription | null;
</script>

{#if exists(inputDescription)}
    <span id={inputDescription.id} class="help-block editor-description">{inputDescription.content}</span>
{/if}
